import { Component, OnInit, OnDestroy } from '@angular/core';
import { BannerAction } from '@dor-mvtrip/shared-angular-components';
import { Router, NavigationStart } from '@angular/router';
import { Store } from '@ngxs/store';
import { Subscription, of } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BusyMessageModalComponent } from './core/components/busy-message-modal/busy-message-modal.component';
import { AppConfigService } from './app-config.service';
import { AuthService } from './core/services/auth.service';
import { map, mergeMap } from 'rxjs/operators';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit, OnDestroy {
	menuActions: BannerAction[];
	menuName: string = null;
	menuFontAwesomeClass: string = null;

	bsModalRef: BsModalRef;
	defaultAuthAction: BannerAction; //Action that fires when the banner 'auth' button is clicked.
	logoClickAction: BannerAction; //Action that fires when banner 'logo' is clicked.
	subscription: Subscription = new Subscription();
	title = 'mli2-client-application';
	busyModalMessage: string;
	sideNavAction: string = 'Hide Menu';
	showNav: boolean = true;
	showSideNav: boolean = false;
	authIconClass = 'fa fa-sign-in';
	isLoggedIn: boolean = false;

	constructor(
		private configService: AppConfigService,
		private router: Router,
		private store: Store,
		private modalService: BsModalService,
		private authService: AuthService
	) {
		this.logoClickAction = {
			name: 'logoClick',
			action: () => {
				this.router.navigate([ '' ]);
			}
		};

		this.defaultAuthAction = {
			name: 'Login',
			action: () => {
				this.authService.login();
			},
			fontAwesomeIconClass: 'fa fa-sign-in'
		};

		this.setMenuActions();
	}

	ngOnInit() {
		const isLoggedInSubscription = this.authService.isLoggedIn$.subscribe(async (isLoggedIn) => {
			this.isLoggedIn = isLoggedIn;

			if (isLoggedIn) {
				const userInfo = await this.authService.getUserInfo().toPromise();
				console.log('user info: ', userInfo);

				if (userInfo) {
					this.menuName = userInfo.loginName;
					this.menuFontAwesomeClass = 'fa fa-user';
				}

				this.defaultAuthAction = {
					name: 'Logout',
					action: () => {
						this.authService.logout().subscribe((response) => {
							window.location.href = this.configService.getConfig().appUrl;
						});
					},
					fontAwesomeIconClass: 'fa fa-sign-out'
				};
			} else {
				this.authIconClass = 'fa fa-sign-in';
				this.defaultAuthAction = {
					name: 'Login',
					action: () => {
						this.authService.login();
					},
					fontAwesomeIconClass: 'fa fa-sign-in'
				};
			}

			this.setMenuActions();
		});

		const busyMessageSubscription = this.store.select((state) => state.app.busyMessage).subscribe((message) => {
			this.busyModalMessage = message;
		});

		const showBusyMessageSubscription = this.store
			.select((state) => state.app.showBusyMessage)
			.subscribe((isBusy) => {
				if (isBusy) {
					this.bsModalRef = this.modalService.show(BusyMessageModalComponent, { ignoreBackdropClick: true });
					this.bsModalRef.content.message = this.busyModalMessage;
				} else {
					if (this.bsModalRef) {
						this.bsModalRef.hide();
					}
				}
			});

		this.subscription.add(busyMessageSubscription);
		this.subscription.add(showBusyMessageSubscription);
		this.subscription.add(isLoggedInSubscription);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	toggleNav() {
		this.showSideNav = !this.showSideNav;

		this.sideNavAction = this.showSideNav ? 'Hide Menu' : 'Show Menu';
	}

	private setMenuActions() {
		this.menuActions = [
			this.defaultAuthAction,
			{
				name: 'ALTS',
				action: () => {
					window.location.href = 'https://alts.mvtrip.alabama.gov/';
				}
			},
			{
				name: 'MVTRIP',
				action: () => {
					window.location.href = 'https://mvtrip.caps.ua.edu/Dashboard/Index';
				}
			}
		];
	}
}
